/* eslint-disable */
import { request } from '@umijs/max'

// 12701-获取所有权限菜单(模块和菜单)
export async function getPermissionMenuAll(params: {menuVersionId: string, parentId?: number}, options?: { [key: string]: any }) {
  return request<any>('/web/v1/permission/permissionItemList', {
    method: 'GET',
    params,
      ...(options || {}),
  })
}

// 12702-新增权限条目(模块和菜单)
export async function addPermissionItem(body: any, options?: { [key: string]: any }) {
  return request<any>('/web/v1/permission/addPermissionItem', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  })
}

// 12703-修改权限条目(模块和菜单)
export async function updatePermissionItem(body: any, options?: { [key: string]: any }) {
  return request<any>('/web/v1/permission/updatePermissionItem', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  })
}

// 12704-删除权限条目(模块和菜单)
export async function deletePermissionItem(data: { id: string | number }, options?: { [key: string]: any }) {
  return request<any>(`/web/v1/permission/deletePermissionItem/${data.id}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...(options || {}),
  })
}

// 12705-根据页面code获取对应的按钮权限(按钮)
export async function getButtonsByPageCode(params: { pageCode: string, menuVersionId?: string }, options?: { [key: string]: any }) {
  return request<any>('/web/v1/permission/permissionItemButtonList', {
    method: 'GET',
    params,
    ...(options || {}),
  })
}

// 12706-新增或修改按钮权限(按钮)
export async function upsertPermissionItemButtonList(body: any, options?: { [key: string]: any }) {
  return request<any>('/web/v1/permission/upsertPermissionItemButtonList', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  })
}
// 12707-删除按钮权限(按钮)
export async function deletePermissionItemButtonList(data: any, options?: { [key: string]: any }) {
  return request<any>(`/web/v1/permission/deletePermissionItemButton/${data.id}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    ...(options || {}),
  })
}